export const BASE_URL = "https://api.rawg.io/api/games";
